import { useRef, useEffect } from "react";
import PropTypes from "prop-types";

import "./ImageHighlighter.css";
const calculatePercentage = (value, total) => (value / total) * 100;

const ImageHighlighter = ({ imageSrc, highlightData }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const img = new Image();

    img.src = imageSrc;
    img.onload = () => {
      // Draw the image on the canvas
      // Get the canvas's current width and height from CSS
      const canvasWidth = canvas.offsetWidth;
      const canvasHeight = canvas.offsetHeight;

      // Set the canvas's internal resolution to match the drawn size
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;
      ctx.drawImage(img, 0, 0, canvasWidth, canvasHeight);

      // Draw the highlights
      highlightData.forEach((area) => {
        const calculatedX = area[0];
        const calculatedY = calculatePercentage(area[1], area[3]);
        const calculatedWidth = canvasWidth;
        const calculatedHeight = calculatePercentage(area[2], area[3]);
        ctx.fillStyle = "rgba(255, 255, 0, 0.4)"; // Yellow with opacity
        ctx.fillRect(
          calculatedX,
          calculatedY,
          calculatedWidth,
          calculatedHeight
        );
      });
    };
  }, [imageSrc, highlightData]);

  return <canvas ref={canvasRef} className="canvas-image-highlight" />;
};

ImageHighlighter.propTypes = {
  imageSrc: PropTypes.string.isRequired,
  highlightData: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number))
    .isRequired,
};

export { ImageHighlighter };
